import { createContext } from 'react';

/**
 * @typedef {{
 *  uri: string,
 *  label: string,
 * }} Crumb
 *
 * @typedef {{
 *  crumbs: Crumb[],
 *  deferredCrumbIds: string[],
 *  register: (...args[]) => void,
 *  unregister: (...args[]) => void,
 *  deferCrumb: (...args[]) => void,
 *  resolveCrumb: (...args[]) => void,
 * }} BreadcrumbsContextType
 */

/**
 * @type {BreadcrumbsContextType} defaultContext
 */
const defaultContext = {
  crumbs: [],
  deferredCrumbIds: [],
  register: () => {},
  unregister: () => {},
  deferCrumb: () => {},
  resolveCrumb: () => {},
};

/**
 * @type {React.Context<BreadcrumbsContextType>} BreadcrumbsContext
 */
const BreadcrumbsContext = createContext(defaultContext);

export default BreadcrumbsContext;
